(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const catalogMenus = document.querySelectorAll('.header__fallback-nav .header__catalog-menu');
    const productMenu = document.querySelector('.header__catalog-menu--products');
    const productDetails = productMenu?.querySelector('details');
    const triggers = productMenu?.querySelectorAll('[data-catalog-trigger]') || [];
    const panels = productMenu?.querySelectorAll('[data-catalog-panel]') || [];
    const firstPanel = productMenu?.querySelector('[data-catalog-trigger].is-active')?.dataset.catalogTrigger || triggers[0]?.dataset.catalogTrigger;
    const closeTimers = new WeakMap();

    if (!catalogMenus.length) return;

    const setPanel = (panelName) => {
      triggers.forEach((trigger) => {
        const isActive = trigger.dataset.catalogTrigger === panelName;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', String(isActive));
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.catalogPanel === panelName);
      });
    };

    const resetPanels = () => {
      if (firstPanel) setPanel(firstPanel);
    };

    const clearCloseTimer = (menu) => {
      window.clearTimeout(closeTimers.get(menu));
    };

    const closeMenu = (menu) => {
      clearCloseTimer(menu);
      const menuDetails = menu.querySelector('details');
      const menuSummary = menu.querySelector('summary');
      menuDetails?.removeAttribute('open');
      menuSummary?.setAttribute('aria-expanded', 'false');
      if (menu === productMenu) resetPanels();
    };

    const closeSiblingMenus = (currentMenu) => {
      catalogMenus.forEach((menu) => {
        if (menu !== currentMenu) closeMenu(menu);
      });
    };

    const setOpen = (menu, isOpen) => {
      clearCloseTimer(menu);
      const menuDetails = menu.querySelector('details');
      const menuSummary = menu.querySelector('summary');
      if (!menuDetails || !menuSummary) return;

      if (isOpen) {
        closeSiblingMenus(menu);
        menuDetails.setAttribute('open', '');
      } else {
        closeMenu(menu);
        return;
      }
      menuSummary.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = (menu) => {
      clearCloseTimer(menu);
      closeTimers.set(menu, window.setTimeout(() => closeMenu(menu), 450));
    };

    catalogMenus.forEach((menu) => {
      const menuDetails = menu.querySelector('details');
      const menuSummary = menu.querySelector('summary');
      const panel = menu.querySelector('.header__catalog-panel');
      if (!menuDetails || !menuSummary) return;
      let openedByHover = false;

      const openOnDesktop = () => {
        if (!desktopQuery.matches) return;
        if (!menuDetails.hasAttribute('open')) openedByHover = true;
        setOpen(menu, true);
      };

      const closeAfterPointerLeaves = () => {
        if (desktopQuery.matches) scheduleClose(menu);
      };

      menu.addEventListener('mouseenter', openOnDesktop);
      menu.addEventListener('mouseleave', closeAfterPointerLeaves);
      menuSummary.addEventListener('mouseenter', openOnDesktop);
      menuSummary.addEventListener('mouseleave', closeAfterPointerLeaves);
      panel?.addEventListener('mouseenter', openOnDesktop);
      panel?.addEventListener('mouseleave', closeAfterPointerLeaves);

      menu.addEventListener('focusout', () => {
        if (!desktopQuery.matches) return;
        window.requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement)) closeMenu(menu);
        });
      });

      menuSummary.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const keepOpenAfterHover = event.detail > 0 && openedByHover;
        openedByHover = false;
        setOpen(menu, keepOpenAfterHover || !menuDetails.hasAttribute('open'));
      });
    });

    triggers.forEach((trigger) => {
      const panelName = trigger.dataset.catalogTrigger;
      trigger.addEventListener('mouseenter', () => setPanel(panelName));
      trigger.addEventListener('focus', () => setPanel(panelName));
      trigger.addEventListener('click', (event) => {
        setPanel(panelName);
        if (trigger.tagName !== 'A' || !trigger.getAttribute('href')) {
          event.preventDefault();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!desktopQuery.matches) return;
      const clickedInsideMenu = Array.from(catalogMenus).some((menu) => menu.contains(event.target));
      if (!clickedInsideMenu) catalogMenus.forEach(closeMenu);
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') catalogMenus.forEach(closeMenu);
    });

    desktopQuery.addEventListener('change', () => catalogMenus.forEach(closeMenu));
    resetPanels();
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
